import { TrackedEvents, trackEvent } from 'analytics';
import { logger } from 'monitor';

import type { Bale } from '../types';

export const trackBaleSopOutcome = (bale: Bale, type: 'frontend' | 'backend' | 'model') => {
  if (bale.analysisStatus === 'rejected-photo') {
    logger.debug('Tracking SOP failure', bale);
    trackEvent(TrackedEvents.EVIDENCE_UPLOAD_SOP_FAILURE, { reason: bale.photoRejectedReason, type });
    return;
  }

  logger.debug('Tracking SOP success', bale);
  trackEvent(TrackedEvents.EVIDENCE_UPLOAD_SOP_SUCCESS);
};
